function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * utils.ts 10.3.1
 * Copyright (c) 2021 Alain Dumesny - see GridStack root license
 */
/** checks for obsolete method names */
// eslint-disable-next-line
export function obsolete(self, f, oldName, newName, rev) {
  var wrapper = function wrapper() {
    console.warn('gridstack.js: Function `' + oldName + '` is deprecated in ' + rev + ' and has been replaced ' + 'with `' + newName + '`. It will be **removed** in a future release');
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return f.apply(self, args);
  };
  wrapper.prototype = f.prototype;
  return wrapper;
}
/** checks for obsolete grid options (can be used for any fields, but msg is about options) */
export function obsoleteOpts(opts, oldName, newName, rev) {
  if (opts[oldName] !== undefined) {
    opts[newName] = opts[oldName];
    console.warn('gridstack.js: Option `' + oldName + '` is deprecated in ' + rev + ' and has been replaced with `' + newName + '`. It will be **removed** in a future release');
  }
}
/** checks for obsolete grid options which are gone */
export function obsoleteOptsDel(opts, oldName, rev, info) {
  if (opts[oldName] !== undefined) {
    console.warn('gridstack.js: Option `' + oldName + '` is deprecated in ' + rev + info);
  }
}
/** checks for obsolete Jquery element attributes */
export function obsoleteAttr(el, oldName, newName, rev) {
  var oldAttr = el.getAttribute(oldName);
  if (oldAttr !== null) {
    el.setAttribute(newName, oldAttr);
    console.warn('gridstack.js: attribute `' + oldName + '`=' + oldAttr + ' is deprecated on this object in ' + rev + ' and has been replaced with `' + newName + '`. It will be **removed** in a future release');
  }
}
/**
 * Utility methods
 */
export var Utils = /*#__PURE__*/function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }
  return _createClass(Utils, null, [{
    key: "getElements",
    value: /** convert a potential selector into actual list of html elements. optional root which defaults to document (for shadow dom) */
    function getElements(els) {
      var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
      if (typeof els === 'string') {
        var doc = 'getElementById' in root ? root : undefined;
        // Note: very common for people use to id='1,2,3' which is only legal as HTML5 id, but not CSS selectors
        // so if we start with a number, assume it's an id and just return that one item...
        // see https://github.com/gridstack/gridstack.js/issues/2234#issuecomment-1523796562
        if (doc && !isNaN(+els[0])) {
          // start with digit
          var el = doc.getElementById(els);
          return el ? [el] : [];
        }
        var list = root.querySelectorAll(els);
        if (!list.length && els[0] !== '.' && els[0] !== '#') {
          list = root.querySelectorAll('.' + els);
          if (!list.length) {
            list = root.querySelectorAll('#' + els);
          }
        }
        return Array.from(list);
      }
      return [els];
    }
    /** convert a potential selector into actual single element. optional root which defaults to document (for shadow dom) */
  }, {
    key: "getElement",
    value: function getElement(els) {
      var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
      if (typeof els === 'string') {
        var doc = 'getElementById' in root ? root : undefined;
        if (!els.length) return null;
        if (doc && els[0] === '#') {
          return doc.getElementById(els.substring(1));
        }
        if (els[0] === '#' || els[0] === '.' || els[0] === '[') {
          return root.querySelector(els);
        }
        // if we start with a digit, assume it's an id (error calling querySelector('#1')) as class are not valid CSS
        if (doc && !isNaN(+els[0])) {
          // start with digit
          return doc.getElementById(els);
        }
        // finally try string, then id, then class
        var el = root.querySelector(els);
        if (doc && !el) {
          el = doc.getElementById(els);
        }
        if (!el) {
          el = root.querySelector('.' + els);
        }
        return el;
      }
      return els;
    }
    /** true if we should resize to content. strict=true when only 'sizeToContent:true' and not a number which lets user adjust */
  }, {
    key: "shouldSizeToContent",
    value: function shouldSizeToContent(n) {
      var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return (n === null || n === void 0 ? void 0 : n.grid) && (strict ? n.sizeToContent === true || n.grid.opts.sizeToContent === true && n.sizeToContent === undefined : !!n.sizeToContent || n.grid.opts.sizeToContent && n.sizeToContent !== false);
    }
    /** returns true if a and b overlap */
  }, {
    key: "isIntercepted",
    value: function isIntercepted(a, b) {
      return !(a.y >= b.y + b.h || a.y + a.h <= b.y || a.x + a.w <= b.x || a.x >= b.x + b.w);
    }
    /** returns true if a and b touch edges or corners */
  }, {
    key: "isTouching",
    value: function isTouching(a, b) {
      return Utils.isIntercepted(a, {
        x: b.x - 0.5,
        y: b.y - 0.5,
        w: b.w + 1,
        h: b.h + 1
      });
    }
    /** returns the area a and b overlap */
  }, {
    key: "areaIntercept",
    value: function areaIntercept(a, b) {
      var x0 = a.x > b.x ? a.x : b.x;
      var x1 = a.x + a.w < b.x + b.w ? a.x + a.w : b.x + b.w;
      if (x1 <= x0) return 0; // no overlap
      var y0 = a.y > b.y ? a.y : b.y;
      var y1 = a.y + a.h < b.y + b.h ? a.y + a.h : b.y + b.h;
      if (y1 <= y0) return 0; // no overlap
      return (x1 - x0) * (y1 - y0);
    }
    /** returns the area */
  }, {
    key: "area",
    value: function area(a) {
      return a.w * a.h;
    }
    /**
     * Sorts array of nodes
     * @param nodes array to sort
     * @param dir 1 for ascending, -1 for descending (optional)
     **/
  }, {
    key: "sort",
    value: function sort(nodes) {
      var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var und = 10000;
      return nodes.sort(function (a, b) {
        var _a$y, _b$y, _a$x, _b$x;
        var diffY = dir * (((_a$y = a.y) !== null && _a$y !== void 0 ? _a$y : und) - ((_b$y = b.y) !== null && _b$y !== void 0 ? _b$y : und));
        if (diffY === 0) return dir * (((_a$x = a.x) !== null && _a$x !== void 0 ? _a$x : und) - ((_b$x = b.x) !== null && _b$x !== void 0 ? _b$x : und));
        return diffY;
      });
    }
    /** find an item by id */
  }, {
    key: "find",
    value: function find(nodes, id) {
      return id ? nodes.find(function (n) {
        return n.id === id;
      }) : undefined;
    }
    /**
     * creates a style sheet with style id under given parent
     * @param id will set the 'gs-style-id' attribute to that id
     * @param parent to insert the stylesheet as first child,
     * if none supplied it will be appended to the document head instead.
     */
  }, {
    key: "createStylesheet",
    value: function createStylesheet(id, parent, options) {
      var style = document.createElement('style');
      var nonce = options === null || options === void 0 ? void 0 : options.nonce;
      if (nonce) style.nonce = nonce;
      style.setAttribute('type', 'text/css');
      style.setAttribute('gs-style-id', id);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (style.styleSheet) {
        // TODO: only CSSImportRule have that and different beast ??
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        style.styleSheet.cssText = '';
      } else {
        style.appendChild(document.createTextNode('')); // WebKit hack
      }
      if (!parent) {
        // default to head
        parent = document.getElementsByTagName('head')[0];
        parent.appendChild(style);
      } else {
        parent.insertBefore(style, parent.firstChild);
      }
      return style.sheet;
    }
    /** removed the given stylesheet id */
  }, {
    key: "removeStylesheet",
    value: function removeStylesheet(id, parent) {
      var target = parent || document;
      var el = target.querySelector('STYLE[gs-style-id=' + id + ']');
      if (el && el.parentNode) el.remove();
    }
    /** inserts a CSS rule */
  }, {
    key: "addCSSRule",
    value: function addCSSRule(sheet, selector, rules) {
      if (typeof sheet.addRule === 'function') {
        sheet.addRule(selector, rules);
      } else if (typeof sheet.insertRule === 'function') {
        sheet.insertRule("".concat(selector, "{").concat(rules, "}"));
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "toBool",
    value: function toBool(v) {
      if (typeof v === 'boolean') {
        return v;
      }
      if (typeof v === 'string') {
        v = v.toLowerCase();
        return !(v === '' || v === 'no' || v === 'false' || v === '0');
      }
      return Boolean(v);
    }
  }, {
    key: "toNumber",
    value: function toNumber(value) {
      return value === null || value.length === 0 ? undefined : Number(value);
    }
  }, {
    key: "parseHeight",
    value: function parseHeight(val) {
      var h;
      var unit = 'px';
      if (typeof val === 'string') {
        if (val === 'auto' || val === '') h = 0;else {
          var match = val.match(/^(-[0-9]+\.[0-9]+|[0-9]*\.[0-9]+|-[0-9]+|[0-9]+)(px|em|rem|vh|vw|%|cm|mm)?$/);
          if (!match) {
            throw new Error("Invalid height val = ".concat(val));
          }
          unit = match[2] || 'px';
          h = parseFloat(match[1]);
        }
      } else {
        h = val;
      }
      return {
        h: h,
        unit: unit
      };
    }
    /** copies unset fields in target to use the given default sources values */
    // eslint-disable-next-line
  }, {
    key: "defaults",
    value: function defaults(target) {
      var _this = this;
      for (var _len2 = arguments.length, sources = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        sources[_key2 - 1] = arguments[_key2];
      }
      sources.forEach(function (source) {
        for (var key in source) {
          if (!source.hasOwnProperty(key)) return;
          if (target[key] === null || target[key] === undefined) {
            target[key] = source[key];
          } else if (_typeof(source[key]) === 'object' && _typeof(target[key]) === 'object') {
            // property is an object, recursively add it's field over... #1373
            _this.defaults(target[key], source[key]);
          }
        }
      });
      return target;
    }
    /** given 2 objects return true if they have the same values. Checks for Object {} having same fields and values (just 1 level down) */
  }, {
    key: "same",
    value: function same(a, b) {
      if (_typeof(a) !== 'object') return a == b;
      if (_typeof(a) !== _typeof(b)) return false;
      // else we have object, check just 1 level deep for being same things...
      if (Object.keys(a).length !== Object.keys(b).length) return false;
      for (var key in a) {
        if (a[key] !== b[key]) return false;
      }
      return true;
    }
    /** copies over b size & position (GridStackPosition), and optionally min/max as well */
  }, {
    key: "copyPos",
    value: function copyPos(a, b) {
      var doMinMax = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (b.x !== undefined) a.x = b.x;
      if (b.y !== undefined) a.y = b.y;
      if (b.w !== undefined) a.w = b.w;
      if (b.h !== undefined) a.h = b.h;
      if (doMinMax) {
        if (b.minW) a.minW = b.minW;
        if (b.minH) a.minH = b.minH;
        if (b.maxW) a.maxW = b.maxW;
        if (b.maxH) a.maxH = b.maxH;
      }
      return a;
    }
    /** true if a and b has same size & position */
  }, {
    key: "samePos",
    value: function samePos(a, b) {
      return a && b && a.x === b.x && a.y === b.y && (a.w || 1) === (b.w || 1) && (a.h || 1) === (b.h || 1);
    }
    /** given a node, makes sure it's min/max are valid */
  }, {
    key: "sanitizeMinMax",
    value: function sanitizeMinMax(node) {
      // remove 0, undefine, null
      if (!node.minW) {
        delete node.minW;
      }
      if (!node.minH) {
        delete node.minH;
      }
      if (!node.maxW) {
        delete node.maxW;
      }
      if (!node.maxH) {
        delete node.maxH;
      }
    }
    /** removes field from the first object if same as the second objects (like diffing) and internal '_' for saving */
  }, {
    key: "removeInternalAndSame",
    value: function removeInternalAndSame(a, b) {
      if (_typeof(a) !== 'object' || _typeof(b) !== 'object') return;
      for (var key in a) {
        var aVal = a[key];
        var bVal = b[key];
        if (key[0] === '_' || aVal === bVal) {
          delete a[key];
        } else if (aVal && _typeof(aVal) === 'object' && bVal !== undefined) {
          Utils.removeInternalAndSame(aVal, bVal);
          if (!Object.keys(aVal).length) {
            delete a[key];
          }
        }
      }
    }
    /** removes internal fields '_' and default values for saving */
  }, {
    key: "removeInternalForSave",
    value: function removeInternalForSave(n) {
      var removeEl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      for (var key in n) {
        if (key[0] === '_' || n[key] === null || n[key] === undefined) delete n[key];
      }
      delete n.grid;
      if (removeEl) delete n.el;
      // delete default values (will be re-created on read)
      if (!n.autoPosition) delete n.autoPosition;
      if (!n.noResize) delete n.noResize;
      if (!n.noMove) delete n.noMove;
      if (!n.locked) delete n.locked;
      if (n.w === 1 || n.w === n.minW) delete n.w;
      if (n.h === 1 || n.h === n.minH) delete n.h;
    }
    /** return the closest parent (or itself) matching the given class */
    // static closestUpByClass(el: HTMLElement, name: string): HTMLElement {
    //   while (el) {
    //     if (el.classList.contains(name)) return el;
    //     el = el.parentElement
    //   }
    //   return null;
    // }
    /** delay calling the given function for given delay, preventing new calls from happening while waiting */
  }, {
    key: "throttle",
    value: function throttle(func, delay) {
      var isWaiting = false;
      return function () {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        if (!isWaiting) {
          isWaiting = true;
          setTimeout(function () {
            func.apply(void 0, args);
            isWaiting = false;
          }, delay);
        }
      };
    }
  }, {
    key: "removePositioningStyles",
    value: function removePositioningStyles(el) {
      var style = el.style;
      if (style.position) {
        style.removeProperty('position');
      }
      if (style.left) {
        style.removeProperty('left');
      }
      if (style.top) {
        style.removeProperty('top');
      }
      if (style.width) {
        style.removeProperty('width');
      }
      if (style.height) {
        style.removeProperty('height');
      }
    }
    /** @internal returns the passed element if scrollable, else the closest parent that will, up to the entire document scrolling element */
  }, {
    key: "getScrollElement",
    value: function getScrollElement(el) {
      if (!el) return document.scrollingElement || document.documentElement; // IE support
      var style = getComputedStyle(el);
      var overflowRegex = /(auto|scroll)/;
      if (overflowRegex.test(style.overflow + style.overflowY)) {
        return el;
      } else {
        return this.getScrollElement(el.parentElement);
      }
    }
    /** @internal */
  }, {
    key: "updateScrollPosition",
    value: function updateScrollPosition(el, position, distance) {
      // is widget in view?
      var rect = el.getBoundingClientRect();
      var innerHeightOrClientHeight = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top < 0 || rect.bottom > innerHeightOrClientHeight) {
        // set scrollTop of first parent that scrolls
        // if parent is larger than el, set as low as possible
        // to get entire widget on screen
        var offsetDiffDown = rect.bottom - innerHeightOrClientHeight;
        var offsetDiffUp = rect.top;
        var scrollEl = this.getScrollElement(el);
        if (scrollEl !== null) {
          var prevScroll = scrollEl.scrollTop;
          if (rect.top < 0 && distance < 0) {
            // moving up
            if (el.offsetHeight > innerHeightOrClientHeight) {
              scrollEl.scrollTop += distance;
            } else {
              scrollEl.scrollTop += Math.abs(offsetDiffUp) > Math.abs(distance) ? distance : offsetDiffUp;
            }
          } else if (distance > 0) {
            // moving down
            if (el.offsetHeight > innerHeightOrClientHeight) {
              scrollEl.scrollTop += distance;
            } else {
              scrollEl.scrollTop += offsetDiffDown > distance ? distance : offsetDiffDown;
            }
          }
          // move widget y by amount scrolled
          position.top += scrollEl.scrollTop - prevScroll;
        }
      }
    }
    /**
     * @internal Function used to scroll the page.
     *
     * @param event `MouseEvent` that triggers the resize
     * @param el `HTMLElement` that's being resized
     * @param distance Distance from the V edges to start scrolling
     */
  }, {
    key: "updateScrollResize",
    value: function updateScrollResize(event, el, distance) {
      var scrollEl = this.getScrollElement(el);
      var height = scrollEl.clientHeight;
      // #1727 event.clientY is relative to viewport, so must compare this against position of scrollEl getBoundingClientRect().top
      // #1745 Special situation if scrollEl is document 'html': here browser spec states that
      // clientHeight is height of viewport, but getBoundingClientRect() is rectangle of html element;
      // this discrepancy arises because in reality scrollbar is attached to viewport, not html element itself.
      var offsetTop = scrollEl === this.getScrollElement() ? 0 : scrollEl.getBoundingClientRect().top;
      var pointerPosY = event.clientY - offsetTop;
      var top = pointerPosY < distance;
      var bottom = pointerPosY > height - distance;
      if (top) {
        // This also can be done with a timeout to keep scrolling while the mouse is
        // in the scrolling zone. (will have smoother behavior)
        scrollEl.scrollBy({
          behavior: 'smooth',
          top: pointerPosY - distance
        });
      } else if (bottom) {
        scrollEl.scrollBy({
          behavior: 'smooth',
          top: distance - (height - pointerPosY)
        });
      }
    }
    /** single level clone, returning a new object with same top fields. This will share sub objects and arrays */
  }, {
    key: "clone",
    value: function clone(obj) {
      if (obj === null || obj === undefined || _typeof(obj) !== 'object') {
        return obj;
      }
      // return Object.assign({}, obj);
      if (obj instanceof Array) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _toConsumableArray(obj);
      }
      return _objectSpread({}, obj);
    }
    /**
     * Recursive clone version that returns a full copy, checking for nested objects and arrays ONLY.
     * Note: this will use as-is any key starting with double __ (and not copy inside) some lib have circular dependencies.
     */
  }, {
    key: "cloneDeep",
    value: function cloneDeep(obj) {
      // list of fields we will skip during cloneDeep (nested objects, other internal)
      var skipFields = ['parentGrid', 'el', 'grid', 'subGrid', 'engine'];
      // return JSON.parse(JSON.stringify(obj)); // doesn't work with date format ?
      var ret = Utils.clone(obj);
      var _loop = function _loop(key) {
        // NOTE: we don't support function/circular dependencies so skip those properties for now...
        if (ret.hasOwnProperty(key) && _typeof(ret[key]) === 'object' && key.substring(0, 2) !== '__' && !skipFields.find(function (k) {
          return k === key;
        })) {
          ret[key] = Utils.cloneDeep(obj[key]);
        }
      };
      for (var key in ret) {
        _loop(key);
      }
      return ret;
    }
    /** deep clone the given HTML node, removing teh unique id field */
  }, {
    key: "cloneNode",
    value: function cloneNode(el) {
      var node = el.cloneNode(true);
      node.removeAttribute('id');
      return node;
    }
  }, {
    key: "appendTo",
    value: function appendTo(el, parent) {
      var parentNode;
      if (typeof parent === 'string') {
        parentNode = Utils.getElement(parent);
      } else {
        parentNode = parent;
      }
      if (parentNode) {
        parentNode.appendChild(el);
      }
    }
    // public static setPositionRelative(el: HTMLElement): void {
    //   if (!(/^(?:r|a|f)/).test(getComputedStyle(el).position)) {
    //     el.style.position = "relative";
    //   }
    // }
  }, {
    key: "addElStyles",
    value: function addElStyles(el, styles) {
      if (styles instanceof Object) {
        var _loop2 = function _loop2(s) {
          if (styles.hasOwnProperty(s)) {
            if (Array.isArray(styles[s])) {
              // support fallback value
              styles[s].forEach(function (val) {
                el.style[s] = val;
              });
            } else {
              el.style[s] = styles[s];
            }
          }
        };
        for (var s in styles) {
          _loop2(s);
        }
      }
    }
  }, {
    key: "initEvent",
    value: function initEvent(e, info) {
      var evt = {
        type: info.type
      };
      var obj = {
        button: 0,
        which: 0,
        buttons: 1,
        bubbles: true,
        cancelable: true,
        target: info.target ? info.target : e.target
      };
      ['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].forEach(function (p) {
        return evt[p] = e[p];
      }); // keys
      ['pageX', 'pageY', 'clientX', 'clientY', 'screenX', 'screenY'].forEach(function (p) {
        return evt[p] = e[p];
      }); // point info
      return _objectSpread(_objectSpread({}, evt), obj);
    }
    /** copies the MouseEvent properties and sends it as another event to the given target */
  }, {
    key: "simulateMouseEvent",
    value: function simulateMouseEvent(e, simulatedType, target) {
      var simulatedEvent = document.createEvent('MouseEvents');
      simulatedEvent.initMouseEvent(simulatedType,
      // type
      true,
      // bubbles
      true,
      // cancelable
      window,
      // view
      1,
      // detail
      e.screenX,
      // screenX
      e.screenY,
      // screenY
      e.clientX,
      // clientX
      e.clientY,
      // clientY
      e.ctrlKey,
      // ctrlKey
      e.altKey,
      // altKey
      e.shiftKey,
      // shiftKey
      e.metaKey,
      // metaKey
      0,
      // button
      e.target // relatedTarget
      );
      (target || e.target).dispatchEvent(simulatedEvent);
    }
    /**
     * defines an element that is used to get the offset and scale from grid transforms
     * returns the scale and offsets from said element
    */
  }, {
    key: "getValuesFromTransformedElement",
    value: function getValuesFromTransformedElement(parent) {
      var transformReference = document.createElement('div');
      Utils.addElStyles(transformReference, {
        opacity: '0',
        position: 'fixed',
        top: 0 + 'px',
        left: 0 + 'px',
        width: '1px',
        height: '1px',
        zIndex: '-999999'
      });
      parent.appendChild(transformReference);
      var transformValues = transformReference.getBoundingClientRect();
      parent.removeChild(transformReference);
      transformReference.remove();
      return {
        xScale: 1 / transformValues.width,
        yScale: 1 / transformValues.height,
        xOffset: transformValues.left,
        yOffset: transformValues.top
      };
    }
    /** swap the given object 2 field values */
  }, {
    key: "swap",
    value: function swap(o, a, b) {
      if (!o) return;
      var tmp = o[a];
      o[a] = o[b];
      o[b] = tmp;
    }
    /** returns true if event is inside the given element rectangle */
    // Note: Safari Mac has null event.relatedTarget which causes #1684 so check if DragEvent is inside the coordinates instead
    //    this.el.contains(event.relatedTarget as HTMLElement)
    // public static inside(e: MouseEvent, el: HTMLElement): boolean {
    //   // srcElement, toElement, target: all set to placeholder when leaving simple grid, so we can't use that (Chrome)
    //   let target: HTMLElement = e.relatedTarget || (e as any).fromElement;
    //   if (!target) {
    //     const { bottom, left, right, top } = el.getBoundingClientRect();
    //     return (e.x < right && e.x > left && e.y < bottom && e.y > top);
    //   }
    //   return el.contains(target);
    // }
    /** true if the item can be rotated (checking for prop, not space available) */
  }, {
    key: "canBeRotated",
    value: function canBeRotated(n) {
      var _n$grid;
      return !(!n || n.w === n.h || n.locked || n.noResize || (_n$grid = n.grid) !== null && _n$grid !== void 0 && _n$grid.opts.disableResize || n.minW && n.minW === n.maxW || n.minH && n.minH === n.maxH);
    }
  }]);
}();